<template>
  <footer class="presentation-cover-footer">
    <p class="presentation-cover-footer__slogan">One life. One planet. One way.</p>
    <p class="presentation-cover-footer__corner">
      <slot name="corner" />
    </p>
  </footer>
</template>

<script>
export default {
  name: 'PresentationCoverFooter',
};
</script>
